export default {
    'InsertUnameEmail': 'Ponga el nombre de usuario o correo electrónico',
    'ChangePass': 'Modificar contraseña',
    'UnameOrEmail': 'Nombre de usuario o correo electrónico',
    'PassRecover': 'Recuperar Contraseña',
    'InsertCurrPass': 'Ponga la contraseña actual',
    'CurrentPass': 'Contraseña actual',
    'NewPass': 'Nueva contraseña',
    'CreateNewPass': 'Escoja una nueva contraseña',
    'ConfirmNewPass': 'Confirme la nueva contraseña',
    'show_pass': 'Mostrar contraseña',
    'hide_pass': 'Ocultar contraseña',
    'RequiredField': 'Campo obligatorio',
    'PassDontMatch': 'La nueva contraseña y su confirmación deben coincidir',
    'PassReq1': 'No puede ser demasiado común',
    'PassReq2': 'Debe contener por lo menos 12 caracteres',
    'PassReq3': 'No puede ser totalmente numérica',
    'SuccessMailSent': 'Hemos enviado un correo electrónico al usuario o a la dirección de correo electrónico proporcionada, siga las instrucciones adjuntas para crear una nueva contraseña',
    'SuccessMailSent2': 'Si no lo ha recibido, póngase en contacto con el Servicio Técnico',
    'SuccessPassReset': 'La contraseña ha sido actualizada correctamente',
    'Send': 'Enviar',
    'UnknownError': 'Se ha producido un error inesperado, inténtelo de nuevo más tarde.',
    'Language': 'Idioma'
}